import { timeParse } from "d3";
import { formatDate_YMD } from "@/_core/_helpers/_helpers";
import { apiService } from "@/_services";

/**
 * Retrieves hedging data with derivatives Valuation
 * @param {object} _this: context variables
 * @param {string} fieldName: field name to update
 * @param {string} fieldShowLoadingName: field name that defines if the field must be shown loading
 */
export function getFutureHedgeCommodityData(
  _this,
  fieldName,
  fieldShowLoadingName,
  isEndProduct = false,
) {
  _this[fieldShowLoadingName] = true;
  let params = {
    method: "GET",
    endpoint: "commodity_future_hedge",
    content_type: "application/json",
    query_params: isEndProduct
      ? {
          date: formatDate_YMD(new Date()),
          end_product: {
            id_assets: _this.selectedAsset.map((d) => d.pk_id_end_product),
          },
          exposure_date: true,
          format: "json",
          portfolios: { id_portfolios: _this.portfolioNumbers },
        }
      : {
          commodity: _this.commodityNumber,
          date: formatDate_YMD(new Date()),
          exposure_date: true,
          format: "json",
          portfolios: { id_portfolios: _this.portfolioNumbers },
        },
  };
  apiService
    .getAll(params)
    .then((data) => {
      data = JSON.parse(JSON.stringify(data));
      data.forEach(function(d) {
        d.date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(d.fixing_date);
        d.premium_value_date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(
          d.premium_value_date,
        );
        d.trade_date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(d.trade_date);
        d.value_date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(d.value_date);
        d.hedged_date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(d.hedged_date);
        d.sale_date = timeParse("%Y-%m-%dT%H:%M:%S.%L")(d.sale_date);
        d.notional = +d.quantity;
        if (d.derivative_type.indexOf("OUT") > -1 && d.new_event) {
          d.hedgeNotional = 0;
        } else {
          if (d.derivative_type.indexOf("IN") > -1 && !d.new_event) {
            d.hedgeNotional = 0;
          } else {
            if (d.buy_sell.indexOf("offset") > -1) {
              d.hedgeNotional = 0;
            } else {
              d.hedgeNotional = +d.notional * d.undelying_position;
            }
          }
        }
        d.cash_flow = 0;
        d.balance = 0;
      });
      _this[fieldName] = data;
      _this[fieldShowLoadingName] = false;
    })
    .catch(function(error) {
      _this[fieldShowLoadingName] = false;
      console.error(error);
    });
}
